var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._g(_vm._b({ref:"input",domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'input',_vm.$attrs,false),_vm.listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }